import { useState, useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import { logError } from "@/lib/errorHandler";

export const useCoach = () => {
  const { user } = useAuth();
  const [isCoach, setIsCoach] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setIsCoach(false);
      setLoading(false);
      return;
    }

    const checkRole = async () => {
      try {
        const { data, error } = await supabase
          .from("user_roles")
          .select("role")
          .eq("user_id", user.id)
          .eq("role", "coach")
          .maybeSingle();

        if (error) {
          logError("coach-role-check", error);
          setIsCoach(false);
        } else {
          setIsCoach(!!data);
        }
      } catch (err) {
        logError("coach-check", err);
        setIsCoach(false);
      } finally {
        setLoading(false);
      }
    };

    checkRole();
  }, [user]);

  return { isCoach, loading };
};
